import {categoryUrlBuilder, searchUrlBuilder} from '@salesforce/retail-react-app/app/utils/url'
import {boldString, capitalize} from '@salesforce/retail-react-app/app/utils/utils'
import {productUrlBuilder} from '../../../utils/url'
import routingObject from '../../../utils/static-routes'
import {decodeHtmlEntities} from '../../../utils/utils'

export default function formatSuggestions(searchSuggestions, input) {
    return {
        categorySuggestions: searchSuggestions?.categorySuggestions?.categories?.map(
            (suggestion) => {
                return {
                    type: 'category',
                    id: suggestion.id,
                    link: categoryUrlBuilder({id: suggestion.id}),
                    name: boldString(suggestion.name, capitalize(input)),
                }
            },
        ),
        productSuggestions: searchSuggestions?.productSuggestions?.products?.map((product) => {
            return {
                type: 'product',
                currency: product.currency,
                price: product.price,
                productId: product.productId,
                name: boldString(product.productName, capitalize(input)),
                link: productUrlBuilder(product),
            }
        }),
        phraseSuggestions: searchSuggestions?.categorySuggestions?.suggestedPhrases?.map(
            (phrase) => {
                return {
                    type: 'phrase',
                    name: boldString(phrase.phrase, capitalize(input)),
                    link: searchUrlBuilder(phrase.phrase),
                }
            },
        ),
        articleSuggestions: searchSuggestions?.articleSuggestions?.map((article) => {
            if (!input || !article?.article_title) return
            let articleCategory = decodeHtmlEntities(article?.article_category)
                .trim()
                .replace(/\s+/g, '-')
                .replace(/[?]/g, '')
            return {
                type: 'article',
                id: article?.article_id,
                link: `${routingObject.FAQ_PATH}/${articleCategory}/a/${article?.article_id}`,
                name: boldString(article?.article_title, capitalize(input)),
            }
        }),
    }
}
